import styled from '@emotion/styled';

import type { ButtonTheme } from '@/components/common/buttons/Button';

export const Wrapper = styled.button<{ themeType: ButtonTheme }>`
  min-height: 40px;
  padding-inline: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 6px;
  border: 1px solid
    ${({ theme, themeType }) => {
      switch (themeType) {
        case 'primary':
          return `${theme.colors.shopl[400]}`;
        case 'secondary':
          return `${theme.colors.neutral[350]}`;
        case 'error':
          return `${theme.colors.red[300]}`;
        default:
          return `${theme.colors.shopl[400]}`;
      }
    }};
  color: ${({ theme, themeType }) => {
    switch (themeType) {
      case 'primary':
        return `${theme.colors.neutral[0]}`;
      case 'secondary':
        return `${theme.colors.neutral[700]}`;
      case 'error':
        return `${theme.colors.neutral[0]}`;
      default:
        return `${theme.colors.neutral[0]}`;
    }
  }};
  background-color: ${({ theme, themeType }) => {
    switch (themeType) {
      case 'primary':
        return `${theme.colors.shopl[300]}`;
      case 'secondary':
        return `${theme.colors.neutral[0]}`;
      case 'error':
        return `${theme.colors.red[200]}`;
      default:
        return `${theme.colors.shopl[300]}`;
    }
  }};

  /* MARK : disabled 스타일 가이드 받고 작업하기 */
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover {
    background-color: ${({ theme, themeType }) => {
      switch (themeType) {
        case 'primary':
          return `${theme.colors.shopl[400]}`;
        case 'secondary':
          return `${theme.colors.neutral[100]}`;
        case 'error':
          return `${theme.colors.red[300]}`;
        default:
          return `${theme.colors.neutral[400]}`;
      }
    }};
  }
`;

export const Label = styled.span<{ themeType: ButtonTheme }>`
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;
